
// Custom Tailored form

// Store the Form as HTML in custom_form variable
var custom_form =
  '<div class="two-third">' +
  '<p class="line-item-property__field"><label for="top">Top</label><input id="top" type="text" name="properties[Top]" required></p>' +
  '<p class="line-item-property__field"><label for="topLength">Length</label><input id="topLength" type="text" name="properties[Top Length]" required></p>' +
  '<p class="line-item-property__field"><label for="chest">Chest</label><input id="chest" type="text" name="properties[Chest]" required></p>' +
  '<p class="line-item-property__field"><label for="bust">Bust</label><input id="bust" type="text" name="properties[Bust]" required></p>' +
  '<p class="line-item-property__field"><label for="waist">Waist</label><input id="waist" type="text" name="properties[Waist]" required></p>' +
  '<p class="line-item-property__field"><label for="hip">Hip</label><input id="hip" type="text" name="properties[Hip]" required></p>' +
  '<p class="line-item-property__field"><label for="shoulder">Shoulder</label><input id="shoulder" type="text" name="properties[Shoulder]" required></p>' +
  '<p class="line-item-property__field"><label for="armHole">Arm Hole</label><input id="armHole" type="text" name="properties[Arm Hole]" required></p>' +
  '<p class="line-item-property__field"><label for="sleeves">Sleeves</label><input id="sleeves" type="text" name="properties[Sleeves]" required></p>' +
  '<p class="line-item-property__field"><label for="collar">Collar</label><input id="collar" type="text" name="properties[Collar]" required></p>' +
  '<p class="line-item-property__field"><label for="frontNeck">Front Neck</label><input id="frontNeck" type="text" name="properties[Front Neck]" required></p>' +
  '<p class="line-item-property__field"><label for="backNeck">Back Neck</label><input id="backNeck" type="text" name="properties[Back Neck]" required></p>' +
  '<p class="line-item-property__field"><label for="bottom">Bottom</label><input id="bottom" type="text" name="properties[Bottom]" required></p>' +
  '<p class="line-item-property__field"><label for="bottomLength">Length</label><input id="bottomLength" type="text" name="properties[Bottom Length]" required></p>' +
  '<p class="line-item-property__field"><label for="bottomWaist">Waist</label><input id="bottomWaist" type="text" name="properties[Bottom Waist]" required></p>' +
  '<p class="line-item-property__field"><label for="knee">Knee</label><input id="knee" type="text" name="properties[Knee]" required></p>' +
  '<p class="line-item-property__field"><label for="calf">Calf</label><input id="calf" type="text" name="properties[Calf]" required></p>' +
  '<p class="line-item-property__field"><label for="thigh">Thigh</label><input id="thigh" type="text" name="properties[Thigh]" required></p>' +
  '<p class="line-item-property__field"><label for="crotch">Crotch</label><input id="crotch" type="text" name="properties[Crotch]" required></p>' +
  '<p class="line-item-property__field"><label for="SpecialInstructions">Special Instructions</label><textarea rows="2" id="SpecialInstructions" name="properties[Special Instructions]" required></textarea></p>' +
  '</div>';

//  Function to inject/remove form
function ShowCustomForm(newvariant) {
  // - If variant title contains "Custom Tailored", inject HTML to DOM
  console.log("newvariant", newvariant);
  if (newvariant.title.includes("Custom")) {
    document.getElementById("custom-size-form").innerHTML = custom_form;
    document
      .getElementById("custom-size-form")
      .scrollIntoView({ behavior: "smooth", block: "center" });
  }
  // Remove form on variant change
  else {
    document.getElementById("custom-size-form").innerHTML = "";
  }
}

// Add listener to check for variant change event and run function
document.addEventListener("variant:change", function (evt) {
  ShowCustomForm(evt.detail.variant);
});



// Custom Tailored form

// Store the Form as HTML in custom_form variable
var custom_forms =
  '<div class="two-third">' +
    '<p class="line-item-property__field"><label for="collar">Collar</label><input id="collar" type="text" name="properties[Collar]" required></p>' +
    '<p class="line-item-property__field"><label for="frontLength">Front Length</label><input id="frontLength" type="text" name="properties[Front Length]" required></p>' +
    '<p class="line-item-property__field"><label for="shoulder">Shoulder</label><input id="shoulder" type="text" name="properties[Shoulder]" required></p>' +
    '<p class="line-item-property__field"><label for="sleeveLength">Sleeve Length</label><input id="sleeveLength" type="text" name="properties[Sleeve Length]" required></p>' +
    '<p class="line-item-property__field"><label for="chest">Chest</label><input id="chest" type="text" name="properties[Chest]" required></p>' +
    '<p class="line-item-property__field"><label for="waist">Waist</label><input id="waist" type="text" name="properties[Waist]" required></p>' +
    '<p class="line-item-property__field"><label for="hips">Hips</label><input id="hips" type="text" name="properties[Hips]" required></p>' +
    '<p class="line-item-property__field"><label for="backLength">Back Length</label><input id="backLength" type="text" name="properties[Back Length]" required></p>' +
    '<p class="line-item-property__field"><label for="crossBack">Cross/Back</label><input id="crossBack" type="text" name="properties[Cross Back]" required></p>' +
    '<p class="line-item-property__field"><label for="headSize">Head Size</label><input id="headSize" type="text" name="properties[Head Size]" required></p>' +
    '<p class="line-item-property__field"><label for="specialInstructions">Special Instructions</label><textarea rows="2" id="specialInstructions" name="properties[Special Instructions]" required></textarea></p>' +
  '</div>';

//  Function to inject/remove form
function ShowCustomForms(newvariant) {
  // - If variant title contains "Custom Tailored", inject HTML to DOM
  console.log("newvariant", newvariant);
  if (newvariant.title.includes("Custom")) {
    document.getElementById("custom-size-form-men").innerHTML = custom_forms;
    document
      .getElementById("custom-size-form-men")
      .scrollIntoView({ behavior: "smooth", block: "center" });
  }
  // Remove form on variant change
  else {
    document.getElementById("custom-size-form-men").innerHTML = "";
  }
}

// Add listener to check for variant change event and run function
document.addEventListener("variant:change", function (evt) {
  ShowCustomForms(evt.detail.variant);
});




